import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import config from "../../config";
import Swal from "sweetalert2";
import XLSX from "xlsx-js-style";
import { ContextBoard } from "../../context/ContextBoard";
import { motion } from "framer-motion";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// Toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Class9Reports() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("secondaryAdminToken");
  const permissions = JSON.parse(sessionStorage.getItem("permissions") || "[]");
  const [loading, setLoading] = useState(false);

  // ---------- MODAL STATES ----------
  const [showDateModal, setShowDateModal] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedReport, setSelectedReport] = useState(null);

  useEffect(() => {
    if (!token) {
      navigate("/secondary-admin");
    }
  }, []);

  useEffect(() => {
    if (!permissions[4]?.caN_VIEW) {
      navigate("/secondary-admin-dashboard");
    }
  }, [permissions, navigate]);

  const reportOptions = [
    {
      label: "Rejected by Accounts",
      url: `${config.API_BASE_URL2}/AdminGetFORejectedReport_CL10`,
      method: "GET",
      dataPath: `data["rejectedReport_list"]`,
      buttonClass: "btn-danger",
    },
    {
      label: "Approved by Accounts",
      url: `${config.API_BASE_URL2}/AdminGetFOApprovedReport_CL10`,
      method: "GET",
      dataPath: `data["approvedReport_list"]`,
      buttonClass: "btn-success",
    },
    {
      label: "Pending at Accounts",
      url: `${config.API_BASE_URL2}/AdminGetFOPendingReport_CL10`,
      method: "GET",
      dataPath: `data["pendingReport_list"]`,
      buttonClass: "btn-primary",
    },
    {
      label: "Payment not Done",
      url: `${config.API_BASE_URL2}/AdminGetChallanNotPaidReport_CL10`,
      method: "GET",
      dataPath: `data["challanNotPaidReport_list"]`,
      buttonClass: "btn-info",
    },
    {
      label: "All Challan",
      url: `${config.API_BASE_URL2}/AdminGetAllChallanReport_CL10`,
      method: "GET",
      dataPath: `data["allChallanReport_list"]`,
      buttonClass: "btn-warning",
    },
    {
      label: "Challan Not Generated",
      url: `${config.API_BASE_URL2}/AdminGetChallanNotGenerateReport_CL10`,
      method: "GET",
      dataPath: `data["challanNotGenerateReport_list"]`,
      buttonClass: "btn-secondary",
    },
    {
      label: "District wise Student Count",
      url: `${config.API_BASE_URL2}/DistWiseStudentCountReport_CL10`,
      method: "POST",
      dataPath: `data["reportDistCount_list"]`,
      buttonClass: "btn-dark",
    },
    {
      label: "District wise School wise Student Count",
      url: `${config.API_BASE_URL2}/AdminDistrictSchoolCount_CL10NEW`,
      method: "POST", // For date filter
      dataPath: `data["adminDistrict_list"]`,
      buttonClass: "btn-success",
    },
  ];

  const reportOptions2 = [
    {
      label: "Subject Duplicate Report",
      url: `${config.API_BASE_URL2}/ReportDuplicateSubject_CL10`,
      method: "GET",
      dataPath: `data["DuplicateSubject_list"]`,
      buttonClass: "btn-danger",
      headers: [
        "CANDIDATE ID",
        "CANDIDATE NAME",
        "SUBJECT CODE",
        "DUPLICATE COUNT",
      ],
    },
    {
      label: "Same Date Subject Clash Report",
      url: `${config.API_BASE_URL2}/ReportExaminationSameDateSubjectErrorList_CL10`,
      method: "GET",
      dataPath: `data["ExaminationSameDateSubjectError_list"]`,
      buttonClass: "btn-primary",
      headers: [
        "SL. NO.",
        "ROLL CODE",
        "ROLL NO.",
        "REGISTRATION NO.",
        "CANDIDATE NAME",
        "SUBJECT 1",
        "SUBJECT 2",
        "SUBJECT 3",
        "SUBJECT 4",
        "SUBJECT 5",
        "SUBJECT 6",
      ],
    },
    {
      label: "Invalid Dob List",
      url: `${config.API_BASE_URL2}/ReportExaminationInvalidDOBList_CL10`,
      method: "GET",
      dataPath: `data["reportExaminationInvalidDob_list"]`,
      buttonClass: "btn-warning",
      headers: [
        "SL. NO.",
        "ROLL CODE",
        "CANDIDATE NAME",
        "MOTHER NAME",
        "FATHER NAME",
        "REGISTRATION NO",
        "DOB",
        "APPEARING",
        "LANGUAGE 1",
        "LANGUAGE 2",
        "COMPULSORY 1",
        "COMPULSORY 2",
        "COMPULSORY 3",
        "ADDITIONAL",
        "STUDENT ID",
      ],
    },

    {
      label: "Centre Wise QP Count Report",
      url: `${config.API_BASE_URL2}/CenterWiseQPCountReport_CL10`,
      method: "GET",
      dataPath: `data["reportCenterWiseQPCount_list"]`,
      buttonClass: "btn-success",
      headers: [
        "SL. NO.",
        "CENTRE CODE",
        "AGR",
        "APR",
        "ARB",
        "AUT",
        "BAW",
        "BNG",
        "COM",
        "EAH",
        "ENG",
        "HEL",
        "HNA",
        "HNB",
        "HO",
        "HSC",
        "IIT",
        "ITS",
        "KHA",
        "KHO",
        "KUR",
        "MSK",
        "MTH",
        "MUN",
        "MUS",
        "NAG",
        "ORA",
        "ORY",
        "PPG",
        "PRN",
        "RET",
        "SCI",
        "SEC",
        "SNK",
        "SNT",
        "SOC",
        "TAT",
        "THO",
        "URD",
      ],
    },
    {
      label: "Centre School Tagging Report",
      url: `${config.API_BASE_URL2}/ReportDistrictCentreWiseTaggedSchoolStudentCount_CL10`,
      method: "GET",
      dataPath: `data["reportTaggedSchoolStudentCount_list"]`,
      buttonClass: "btn-info",
      headers: [
        "SL. NO.",
        "DIST. CODE",
        "DISTRICT NAME",
        "CENTRE CODE",
        "CENTRE NAME",
        "CENTRE STRENGTH",
        "TAGGED SCHOOL CODE",
        "TAGGED SCHOOL NAME",
        "NO. OF STUDENTS IN TAGGED SCHOOL",
      ],
    },
    {
      label: "Centre Wise Candidate Count Report",
      url: `${config.API_BASE_URL2}/ReportDistrictWiseCandidatesCount_CL10`,
      method: "GET",
      dataPath: `data["reportDistrictWiseCandidate_list"]`,
      buttonClass: "btn-secondary",
      headers: [
        "SL. NO.",
        "DIST. CODE",
        "DISTRICT NAME",
        "CENTRE CODE",
        "CENTRE NAME",
        "TOTAL COUNT",
      ],
    },
    // {
    //   label: "Vocational Subject Selection Report",
    //   url: `${config.API_BASE_URL2}/ReportVocationalSubjectCandidatesListForJAC_CL10`,
    //   method: "GET",
    //   dataPath: `data["vocationalSubjectCandidates_list"]`,
    //   buttonClass: "btn-dark",
    //   headers: [
    //     "SL. NO.",
    //     "DISTRICT",
    //     "SCHOOL NAME",
    //     "SCHOOL CODE (UDISE)",
    //     "HEAD / CO-ORDINATING PERSON",
    //     "CONTACT NO.",
    //     "EMAIL ID",
    //     "CANDIDATE NAME",
    //     "CLASS / STANDARD",
    //     "GENDER (M/F)",
    //     "DATE OF BIRTH (DD-MM-YYYY)",
    //     "STUDENT ID 1 (AADHAAR)",
    //     "STUDENT ID 2 (REGISTRATION NO.)",
    //     "FATHER'S NAME",
    //     "CATEGORY (GEN/OBC/SC/ST)",
    //     "SUBJECT",
    //     "JOB ROLE",
    //     "ASSESSMENT LEVEL",
    //     "DATE OF ASSESSMENT",
    //     "ASSESSOR NAME",
    //     "ASSESSOR CONTACT NO.",
    //     "ASSESSOR EMAIL ID",
    //   ],
    // },
     {
      label: "Vocational Subject Selection Report",
      url: `${config.API_BASE_URL2}/ReportVocationalSubjectCandidatesListForJAC_CL10`,
      method: "GET",
      buttonClass: "btn-dark",
      isS3Download: true, // Direct server download for heavy 60k dataset
    },
    {
      label: "Practical Subject QP Count Report",
      url: `${config.API_BASE_URL2}/ReportExaminationPracticalStatement_CL10`,
      method: "GET",
      dataPath: `data["reportExaminationPracticalStatement_list"]`,
      buttonClass: "btn-info",
      headers: [
        "SL. NO.",
        "SCHOOL CODE",
        "SCHOOL NAME",
        "TOTAL NO. OF CANDIDATES",
        "SCI",
        "MUS",
        "HSC",
        "IIT",
        "ITS",
        "HEL",
        "MAE",
        "SEC",
        "RET",
        "BAW",
        "TAT",
        "AGR",
        "APR",
        "AUT",
        "EAH",
        "MSK",
        "THO",
      ],
    },
    {
      label: "Blind Candidate Report",
      url: `${config.API_BASE_URL2}/ReportExaminationBlindCandidatesList_CL10`,
      method: "GET",
      dataPath: `data["reportExaminationBlindCandidates_list"]`,
      buttonClass: "btn-primary",
      headers: [
        "SL. NO.",
        "ROLL CODE",
        "CANDIDATE NAME",
        "MOTHER NAME",
        "FATHER NAME",
        "REGISTRATION NO.",
        "DOB",
        "APPEARING",
        "LANGUAGE 1",
        "LANGUAGE 2",
        "COMPULSORY 1",
        "COMPULSORY 2",
        "COMPULSORY 3",
        "ADDITIONAL",
        "STUDENT ID",
      ],
    },
    {
      label: "Finance Report",
      url: `${config.API_BASE_URL2}/ReportFinance_CL10`,
      method: "GET",
      dataPath: `data["reportFinance_list"]`,
      buttonClass: "btn-success",
      headers: [
        "SL. NO.",
        "DIST. CODE",
        "SCHOOL CODE",
        "SCHOOL NAME",
        "REGULAR GIRLS",
        "REGULAR BOYS (GENERAL/EWS)",
        "REGULAR BOYS (SC/ST/BC1/BC2)",
        "PRIVATE GIRLS/BOYS",
        "EX-REGULAR GIRLS/BOYS (1ST ATTEMPT)",
        "EX-CANDIDATE GIRLS/BOYS (2ND ATTEMPT)",
        "NO. OF CANDIDATES (GIRLS/BOYS) - IMPROVEMENT",
        "NO. OF CANDIDATES (GIRLS/BOYS) - 2ND ATTEMPT IMPROVEMENT",
        "TOTAL CANDIDATES",
        "ODPPM FEES (120)",
        "EXAM FEES (200/250)",
        "LOCAL LEVY (220)",
        "MARK SHEET (320)",
        "PROVISIONAL MIGRATION CERTIFICATE (200)",
        "RE-REGISTRATION FEES (200)",
        "MISC. EXPENSES (120)",
        "LATE FINE (500)",
        "CHALLAN NO.",
        "BANK JOURNAL NUMBER",
        "CHALLAN AMOUNT",
        "PAYMENT DATE",
      ],
    },
  ];

  // ---------------- FETCH WITHOUT DATE --------------------
  const fetchReportData = async (reportLabel) => {
    const reportConfig = reportOptions.find((r) => r.label === reportLabel);
    if (!reportConfig) {
      Swal.fire("Invalid report type.", "", "error");
      return;
    }

    if (!token) {
      Swal.fire("Auth Error", "Token is missing. Please login.", "error");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(reportConfig.url, {
        method: reportConfig.method,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();
      const extractedData =
        getValueFromPath(result, reportConfig.dataPath) || [];

      if (!extractedData.length) {
        Swal.fire("No data found.", "", "info");
        return;
      }

      generateExcel(extractedData, reportConfig.label);
    } catch (error) {
      Swal.fire("Error", "Error fetching report.", "error");
    } finally {
      setLoading(false);
    }
  };

  // const fetchReportData2 = async (reportLabel) => {
  //   const reportConfig = reportOptions2.find((r) => r.label === reportLabel);
  //   if (!reportConfig) {
  //     Swal.fire("Invalid report type.", "", "error");
  //     return;
  //   }

  //   if (!token) {
  //     Swal.fire("Auth Error", "Token is missing. Please login.", "error");
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     const response = await fetch(reportConfig.url, {
  //       method: reportConfig.method,
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "application/json",
  //       },
  //     });

  //     const result = await response.json();
  //     const extractedData =
  //       getValueFromPath(result, reportConfig.dataPath) || [];

  //     if (!extractedData.length) {
  //       Swal.fire("No data found.", "", "info");
  //       return;
  //     }

  //     generateExcel2(extractedData, reportConfig);
  //   } catch (error) {
  //     Swal.fire("Error", "Error fetching report.", "error");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
 const fetchReportData2 = async (reportLabel) => {
    const reportConfig = reportOptions2.find((r) => r.label === reportLabel);
    if (!reportConfig) {
      Swal.fire("Invalid report type.", "", "error");
      return;
    }
  if (reportConfig.isS3Download) {
      handleS3FileDownload(reportConfig);
      return;
    }
    if (!token) {
      Swal.fire("Auth Error", "Token is missing. Please login.", "error");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(reportConfig.url, {
        method: reportConfig.method,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();
      const extractedData =
        getValueFromPath(result, reportConfig.dataPath) || [];

      if (!extractedData.length) {
        Swal.fire("No data found.", "", "info");
        return;
      }

      generateExcel2(extractedData, reportConfig);
    } catch (error) {
      Swal.fire("Error", "Error fetching report.", "error");
    } finally {
      setLoading(false);
    }
  };
   const handleS3FileDownload = async (reportConfig) => {
  if (!token) {
    Swal.fire("Auth Error", "Token is missing. Please login.", "error");
    return;
  }

  setLoading(true);
  try {
    const response = await fetch(reportConfig.url, {
      method: reportConfig.method,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();

    if (!response.ok || !result.fileUrl) {
      throw new Error(result.message || "Failed to generate report.");
    }

    // Direct window trigger (replicates pasting the URL in the browser bar)
    const downloadWindow = window.open(result.fileUrl, "_self");
    if (!downloadWindow) {
      window.location.href = result.fileUrl;
    }

    Swal.fire("Success", "Report download started.", "success");
  } catch (error) {
    console.error(error);
    Swal.fire("Error", error.message || "Error downloading report.", "error");
  } finally {
    setLoading(false);
  }
};
  // ---------------- FETCH WITH DATE (MODAL) --------------------
  const fetchReportWithDate = async () => {
    if (!fromDate || !toDate) {
      toast.error("Please select both dates!");
      return;
    }

    // 🚫 Prevent selecting To Date earlier than From Date
    if (new Date(toDate) < new Date(fromDate)) {
      toast.error("To Date cannot be earlier than From Date!");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(selectedReport.url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          FromDate: fromDate,
          ToDate: toDate,
        }),
      });

      const result = await response.json();
      const extractedData =
        getValueFromPath(result, selectedReport.dataPath) || [];

      if (!extractedData.length) {
        toast.error("No data found for selected date range");
        return;
      }

      generateExcel(extractedData, selectedReport.label);
      setShowDateModal(false);
    } catch (err) {
      toast.error("Error fetching report");
    } finally {
      setLoading(false);
    }
  };

  const getValueFromPath = (obj, path) => {
    try {
      return path
        .replace(/\[(["']?)([^\[\]"']+)\1\]/g, ".$2")
        .replace(/^\./, "")
        .split(".")
        .reduce((acc, key) => acc?.[key], obj);
    } catch {
      return undefined;
    }
  };

  const generateExcel = (data, report) => {
    try {
      const reportTitle = String(
        typeof report === "string" ? report : report?.label || "Report",
      );
      const dataKeys = Object.keys(data[0] || {});
      const headers = ["Sl. No.", ...dataKeys];
      const formattedHeaders = Array.isArray(report?.headers)
        ? report.headers
        : ["SL. NO.", ...dataKeys.map((k) => k.toUpperCase())];

      const ws = XLSX.utils.aoa_to_sheet([formattedHeaders]);

      const rows = data.map((item, i) => [
        i + 1,
        ...dataKeys.map((key) => item[key] ?? ""),
      ]);

      const hasGrandTotal =
        report?.hasGrandTotal ||
        reportTitle.includes("Count Report") ||
        reportTitle.includes("QP Count");

      if (hasGrandTotal && data.length > 0) {
        const secondKeyVal =
          dataKeys.length > 1
            ? data.find(
              (d) => d[dataKeys[1]] !== null && d[dataKeys[1]] !== undefined,
            )?.[dataKeys[1]]
            : null;
        const isSecondKeyString =
          typeof secondKeyVal === "string" && isNaN(Number(secondKeyVal));

        const totalRow = [
          "", // SL. NO.
          ...dataKeys.map((key, kIndex) => {
            if (isSecondKeyString && kIndex === 1) {
              return "GRAND TOTAL";
            }
            if (isSecondKeyString && kIndex < 1) {
              return "";
            }
            if (!isSecondKeyString && kIndex === 0) {
              return "GRAND TOTAL";
            }

            const firstVal = data.find(
              (d) => d[key] !== null && d[key] !== undefined,
            )?.[key];
            const isNumeric =
              typeof firstVal === "number" ||
              (typeof firstVal === "string" &&
                !isNaN(Number(firstVal)) &&
                firstVal.trim() !== "");

            if (isNumeric) {
              return data.reduce(
                (sum, item) => sum + (Number(item[key]) || 0),
                0,
              );
            }
            return "";
          }),
        ];
        rows.push(totalRow);
      }

      XLSX.utils.sheet_add_aoa(ws, rows, { origin: -1 });

      ws["!cols"] = formattedHeaders.map(() => ({ wch: 20 }));

      // Format cells: Headers bold & center aligned, data center aligned only, Grand Total row bold & center aligned
      const range = XLSX.utils.decode_range(ws["!ref"] || "A1");
      const lastRowIndex = range.e.r;

      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellAddress]) continue;

          if (R === 0) {
            // Header row: bold & center aligned
            ws[cellAddress].s = {
              font: { bold: true },
              alignment: { horizontal: "center", vertical: "center", wrapText: true },
            };
          } else if (hasGrandTotal && R === lastRowIndex) {
            // Grand Total row: bold & center aligned
            ws[cellAddress].s = {
              font: { bold: true },
              alignment: { horizontal: "center", vertical: "center" },
            };
          } else {
            // Data rows: center align only
            ws[cellAddress].s = {
              alignment: { horizontal: "center", vertical: "center" },
            };
          }
        }
      }

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Report");

      const safeTitle = String(reportTitle || "Report");
      const safeFileName = `Secondary_Report_CL10_${safeTitle.replace(
        /[^a-zA-Z0-9]/g,
        "_",
      )}.xlsx`;

      XLSX.writeFile(wb, safeFileName);

      Swal.fire("Success", "Excel file downloaded", "success");
    } catch (err) {
      Swal.fire("Error", "Failed to generate Excel", "error");
    }
  };

  const generateExcel2 = (data, report) => {
    try {
      if (!data || data.length === 0) {
        Swal.fire("Info", "No data available", "info");
        return;
      }

      const reportLabel = String(
        typeof report === "string" ? report : report?.label || "Report",
      );
      const apiKeys = Object.keys(data[0]);

      const formattedHeaders = report?.headers || [
        "SL. NO.",
        ...apiKeys.map((key) => key.toUpperCase()),
      ];

      const ws = XLSX.utils.aoa_to_sheet([formattedHeaders]);

      const rows = data.map((item, index) => [
        index + 1,
        ...apiKeys.map((key) => item[key] ?? ""),
      ]);

      const hasGrandTotal =
        report?.hasGrandTotal ||
        reportLabel === "Centre Wise QP Count Report" ||
        reportLabel === "Practical Subject QP Count Report" ||
        reportLabel.includes("QP Count") ||
        reportLabel.includes("Count Report");

      if (hasGrandTotal && data.length > 0) {
        const secondKeyVal =
          apiKeys.length > 1
            ? data.find(
              (d) => d[apiKeys[1]] !== null && d[apiKeys[1]] !== undefined,
            )?.[apiKeys[1]]
            : null;
        const isSecondKeyString =
          typeof secondKeyVal === "string" && isNaN(Number(secondKeyVal));

        const totalRow = [
          "", // SL. NO.
          ...apiKeys.map((key, kIndex) => {
            if (isSecondKeyString && kIndex === 1) {
              return "GRAND TOTAL";
            }
            if (isSecondKeyString && kIndex < 1) {
              return "";
            }
            if (!isSecondKeyString && kIndex === 0) {
              return "GRAND TOTAL";
            }

            const firstVal = data.find(
              (d) => d[key] !== null && d[key] !== undefined,
            )?.[key];
            const isNumeric =
              typeof firstVal === "number" ||
              (typeof firstVal === "string" &&
                !isNaN(Number(firstVal)) &&
                firstVal.trim() !== "");

            if (isNumeric) {
              return data.reduce(
                (sum, item) => sum + (Number(item[key]) || 0),
                0,
              );
            }
            return "";
          }),
        ];
        rows.push(totalRow);
      }

      XLSX.utils.sheet_add_aoa(ws, rows, { origin: -1 });

      ws["!cols"] = formattedHeaders.map(() => ({ wch: 20 }));

      // Format cells: Headers bold & center aligned, data center aligned only, Grand Total row bold & center aligned
      const range = XLSX.utils.decode_range(ws["!ref"] || "A1");
      const lastRowIndex = range.e.r;

      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellAddress]) continue;

          if (R === 0) {
            // Header row: bold & center aligned
            ws[cellAddress].s = {
              font: { bold: true },
              alignment: { horizontal: "center", vertical: "center", wrapText: true },
            };
          } else if (hasGrandTotal && R === lastRowIndex) {
            // Grand Total row: bold & center aligned
            ws[cellAddress].s = {
              font: { bold: true },
              alignment: { horizontal: "center", vertical: "center" },
            };
          } else {
            // Data rows: center align only
            ws[cellAddress].s = {
              alignment: { horizontal: "center", vertical: "center" },
            };
          }
        }
      }

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Report");

      const safeFileName = `Secondary_Report_CL10_${reportLabel.replace(
        /[^a-zA-Z0-9]/g,
        "_",
      )}.xlsx`;

      XLSX.writeFile(wb, safeFileName);

      Swal.fire("Success", "Excel file downloaded", "success");
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to generate Excel", "error");
    }
  };

  const handleChangeFromDate = (date) => {
    if (date) {
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();

      setFromDate(`${dd}-${mm}-${yyyy}`);
    } else {
      setFromDate("");
    }
  };

  const handleChangeToDate = (date) => {
    if (date) {
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();

      setToDate(`${dd}-${mm}-${yyyy}`);
    } else {
      setToDate("");
    }
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        style={{ zIndex: "100001" }}
      />
      <div className="container-scroller">
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}

        {/* -------------------- DATE MODAL -------------------- */}
        {showDateModal && (
          <motion.div
            className="modal-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <motion.div
              initial={{ scale: 0.6, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              className="modal-content"
              style={{
                background: "#fff",
                padding: "25px",
                borderRadius: "10px",
                width: "400px",
              }}
            >
              <h4>Select Date Range</h4>

              {/* ---------------- FROM DATE ---------------- */}
              <div className="form-group mt-3">
                <label>From Date</label>
                {/* <DatePicker
                  selected={fromDate ? new Date(fromDate) : null}
                  onChange={(date) =>
                    setFromDate(date ? date.toISOString().split("T")[0] : "")
                  }
                  dateFormat="dd-MM-yyyy"
                  className="form-control"
                  placeholderText="Select From Date"
                  minDate={new Date("2025-01-01")}
                  maxDate={new Date()}
                /> */}
                <DatePicker
                  minDate={new Date(2025, 10, 18)}
                  maxDate={new Date()}
                  selected={
                    fromDate
                      ? (() => {
                        const [dd, mm, yyyy] = fromDate.split("-");
                        return new Date(
                          Number(yyyy),
                          Number(mm) - 1,
                          Number(dd),
                        );
                      })()
                      : null
                  }
                  onChange={(date) => handleChangeFromDate(date)}
                  dateFormat="dd-MM-yyyy"
                  className="form-control"
                  placeholderText="Select From Date"
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>

              {/* ---------------- TO DATE ---------------- */}
              <div className="form-group mt-3">
                <label>To Date</label>
                {/* <DatePicker
                  selected={toDate ? new Date(toDate) : null}
                  onChange={(date) =>
                    setToDate(date ? date.toISOString().split("T")[0] : "")
                  }
                  dateFormat="dd-MM-yyyy"
                  className="form-control"
                  placeholderText="Select To Date"
                  minDate={
                    fromDate ? new Date(fromDate) : new Date("2025-01-01")
                  }
                  maxDate={new Date()}
                /> */}
                <DatePicker
                  minDate={
                    fromDate
                      ? (() => {
                        const [dd, mm, yyyy] = fromDate.split("-");
                        return new Date(
                          Number(yyyy),
                          Number(mm) - 1,
                          Number(dd),
                        );
                      })()
                      : new Date(2025, 0, 1)
                  }
                  maxDate={new Date()}
                  selected={
                    toDate
                      ? (() => {
                        const [dd, mm, yyyy] = toDate.split("-");
                        return new Date(
                          Number(yyyy),
                          Number(mm) - 1,
                          Number(dd),
                        );
                      })()
                      : null
                  }
                  onChange={(date) => handleChangeToDate(date)}
                  dateFormat="dd-MM-yyyy"
                  className="form-control"
                  placeholderText="Select To Date"
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>

              <div className="mt-4 d-flex justify-content-between">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowDateModal(false);
                    setFromDate("");
                    setToDate("");
                  }}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-success"
                  onClick={fetchReportWithDate}
                >
                  Download
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}

        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <section className="content-header mb-4">
                <h1>
                  <i className="fa fa-university" /> Class X Reports
                </h1>
                <ol className="breadcrumb">
                  <li>
                    <a
                      onClick={() => navigate("/secondary-admin-dashboard")}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fa fa-tachometer mr-2"></i> Home
                    </a>
                  </li>
                  <li className="active">Secondary Admin Reports Class X</li>
                </ol>
              </section>

              <div className="row">
                <div className="col-md-4">
                  <div className="card">
                    <div className="card-header">
                      <h5>Class X Reports</h5>
                    </div>
                    <div className="card-body">
                      <table className="table">
                        <tbody>
                          {reportOptions.map((report, index) => (
                            <tr key={index}>
                              <td>
                                <button
                                  className={`btn ${report.buttonClass} w-100`}
                                  style={{ textAlign: "left" }}
                                  onClick={() => {
                                    if (
                                      report.label ===
                                      "District wise School wise Student Count" ||
                                      report.label ===
                                      "District wise Student Count"
                                    ) {
                                      setSelectedReport(report);
                                      setShowDateModal(true);
                                    } else {
                                      fetchReportData(report.label);
                                    }
                                  }}
                                >
                                  <i className="fa fa-download excel-icon-rounded"></i>
                                  &nbsp;
                                  {report.label}
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="card">
                    <div className="card-header">
                      <h5>Class X Pre Exam Report</h5>
                    </div>
                    <div className="card-body">
                      <table className="table">
                        <tbody>
                          {reportOptions2.map((report, index) => (
                            <tr key={index}>
                              <td>
                                <button
                                  className={`btn ${report.buttonClass} w-100`}
                                  style={{ textAlign: "left" }}
                                  onClick={() => {
                                    if (
                                      report.label ===
                                      "District wise School wise Student Count" ||
                                      report.label ===
                                      "District wise Student Count"
                                    ) {
                                      setSelectedReport(report);
                                      setShowDateModal(true);
                                    } else {
                                      fetchReportData2(report.label);
                                    }
                                  }}
                                >
                                  <i className="fa fa-download excel-icon-rounded"></i>
                                  &nbsp;
                                  {report.label}
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default Class9Reports;
